import { useSearchParams } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import HeroHot from "./components/HeroHot";
import ColumnSection from "./components/ColumnSection";
import LatestFeed from "./components/LatestFeed";
import FeaturedBands from "./components/FeaturedBands";
import TipsBand from "./components/TipsBand";
import ReputationBand from "./components/ReputationBand";
import FaqSection from "./components/FaqSection";
import SearchPanel from "./components/SearchPanel";
import { SITE_NAME } from "@/mocks/site";
import { STORIES } from "@/mocks/stories";
import { FAQ_ITEMS } from "@/lib/content";

function buildJsonLd() {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const faq = FAQ_ITEMS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  }));
  const items = STORIES.slice(0, 6).map((s) => ({
    "@type": "ListItem",
    position: STORIES.indexOf(s) + 1,
    name: s.title,
    url: `${origin}/story/${s.slug}`,
  }));
  return [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: SITE_NAME,
      description: "大学吃瓜官网汇集校园恋爱故事、表白现场、分手内幕等校园情感八卦，天天更新。",
      potentialAction: {
        "@type": "SearchAction",
        target: `${origin}/?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: SITE_NAME,
      url: origin,
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "最新瓜文",
      itemListElement: items,
    },
    { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faq },
  ];
}

export default function Home() {
  const [sp] = useSearchParams();
  const q = (sp.get("q") || "").trim();

  return (
    <>
      <Seo
        title="大学吃瓜官网_恋爱故事_分手内幕_表白现场天天更新"
        description="大学吃瓜官网汇集大学生恋爱故事、情侣纠纷、表白现场、分手内幕、情感纠葛等校园情感八卦，最新现场直击，天天更新，满足你的全部吃瓜好奇心。"
        keywords="大学吃瓜,大学吃瓜恋爱故事,大学吃瓜分手内幕,大学吃瓜表白现场,大学吃瓜情侣纠纷"
        jsonLd={buildJsonLd()}
      />
      {q ? <SearchPanel keyword={q} /> : (
        <>
          <HeroHot />
          <ColumnSection />
          <LatestFeed />
          <FeaturedBands />
          <TipsBand />
          <ReputationBand />
        </>
      )}
      <FaqSection />
    </>
  );
}